<template>
  <div>
    <div class="v-agreement-wrap">
      <div class="title">
        {{ $t('agreement.title') }}
      </div>
      <p v-for="(item, index) in $t('agreement.p')" :key="index">{{ item }}</p>
    </div>
    <div class="v-btn-box text-right">
      <el-button type="primary" plain @click="go">{{ $t('agreement.canlce') }}</el-button>
      <el-button type="primary" @click="go">{{
        $t('agreement["Agree and continue"]')
      }}</el-button>
    </div>
  </div>
</template>
<script>
export default {
    methods:{
        go(){
          this.closeBrowserPage()
        }
    }
}
</script>
<style lang="stylus" scoped>
.v-agreement-wrap{
    width:100%;
    max-width: $container-width;
    margin:40px auto;
    padding:16px;
    background:$color-white;
    .title{
        margin-bottom:50px;
        font-size:30px;
        text-align:center;
        font-weight:600;
    }
    p{
        margin-bottom:15px;
    }
    
}
.v-btn-box{
        width:100%;
        max-width:$container-width;
        margin:32px auto;  
    }
</style>
